import { useEffect, useState } from 'react'
import { useAppRootCompRef } from '../AppContext'

const MAX_WIDTH_MOBILE = 768
export const BREAKPOINT_MOBILE = `(max-width: ${MAX_WIDTH_MOBILE}px)`

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false)
  const appRootCompRef = useAppRootCompRef()

  useEffect(() => {
    const checkIfMobile = () => {
      if (appRootCompRef?.current) {
        const componentWidth = appRootCompRef.current.clientWidth
        return componentWidth <= MAX_WIDTH_MOBILE
      }
      console.error('Error: No AppRootCompRef found')
      return false
    }

    const handleResize = () => {
      if (appRootCompRef?.current) {
        setIsMobile(checkIfMobile())
      }
    }

    if (appRootCompRef?.current) {
      handleResize()
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [appRootCompRef])

  return isMobile
}

export const useIsPortrait = () => {
  const [isPortrait, setIsPortrait] = useState(false)
  const appRootCompRef = useAppRootCompRef()

  useEffect(() => {
    const checkIfPortrait = () => {
      if (appRootCompRef?.current) {
        const componentWidth = appRootCompRef.current.clientWidth
        const viewportHeight = window.innerHeight
        return componentWidth < viewportHeight
      }
      console.error('Error: No AppRootCompRef found')
      return false
    }

    const handleResize = () => {
      if (appRootCompRef?.current) {
        setIsPortrait(checkIfPortrait())
      }
    }

    if (appRootCompRef?.current) {
      handleResize()
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [appRootCompRef])

  return isPortrait
}
